import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs, bounds } from "../utils/index"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"
import Sticky from "../../scripts/components/Sticky"
import store from "../store"
import { ScrollTrigger } from "../libraries/gsap/index"

export default class SideBySideText extends Component {
  constructor(obj) {
    super(obj)

    this.splitText = qsa("[data-split]", this.el)
    this.textSplitter = new TextSplitScrollTrigger({
      el: this.el,
      splitText: this.splitText,
      animate: this.animate.bind(this),
    })

    gsap.set(this.el, { autoAlpha: 0 })
  }

  animate() {
    const leftText = qsa(".left .line-0", this.el)
    const rightText = qsa(".right .line-0", this.el)

    gsap.from(leftText, {
      y: 50,
      duration: 1.2,
      autoAlpha: 0,
      stagger: 0.1,
      scrollTrigger: {
        trigger: leftText,
        start: "top bottom",
      },
    })

    gsap.from(rightText, {
      y: 50,
      duration: 1.2,
      autoAlpha: 0,
      stagger: 0.1,
      scrollTrigger: {
        trigger: rightText,
        start: "top bottom",
      },
    })

    gsap.set(this.el, { autoAlpha: 1 })
  }
}
